// extracted by mini-css-extract-plugin
export default {"categoryItem":"panelMain_categoryItem"};